import { guardRules } from "@/mocks/gossipData";
import { SectionHead } from "./ui";

export function GuardRules() {
  return (
    <section id="guard" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6">
        <SectionHead
          index="06"
          kicker="编辑守则 · 我们对内容的立场"
          title="圈内守则：先核实，再说话"
          desc="这条频道做的是把争议讲清楚，不是把一个人讲臭。所有规则都写在明面上，也欢迎你随时监督。"
          tone="accent"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {guardRules.map((g) => (
            <div
              key={g.title}
              className="group rounded-lg border border-background-200 bg-background-50 p-5 transition hover:border-accent-300"
            >
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-accent-50">
                <i className={`${g.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-extrabold text-foreground-950">{g.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{g.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ReportCta() {
  return (
    <section id="report" className="scroll-mt-24 border-y border-primary-900/30 bg-primary-950 text-primary-100">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-4 py-14 md:px-6 lg:grid-cols-2">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-800 bg-primary-900/50 px-3 py-1 text-xs font-semibold text-accent-300">
            <i className="ri-megaphone-line"></i> 投稿 · 澄清 · 申诉通道
          </div>
          <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
            你有线索，也要给当事人
            <br />
            一个开口的位置
          </h2>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-primary-200">
            被坑的经历、看不惯的流程、存疑的账目，都可以投过来；如果你是被提及的一方，也欢迎提交说明。核实后，该补充的补充、该澄清的澄清、该撤下的撤下。
          </p>
          <ul className="mt-6 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
            {[
              "线索类：附时间地点与佐证",
              "澄清类：提交完整说明与证明",
              "撤销类：本人或监护人申诉",
              "进度：受理后 48h 内回复",
            ].map((it) => (
              <li key={it} className="flex items-center gap-2 text-sm text-primary-100">
                <i className="ri-checkbox-circle-line text-accent-400"></i>
                {it}
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-xl border border-primary-800 bg-primary-900/40 p-6">
          <div className="flex items-center justify-between">
            <h3 className="font-heading text-lg font-extrabold text-background-50">提交线索 / 说明</h3>
            <span className="inline-flex items-center gap-1 rounded-full bg-primary-800/60 px-2.5 py-1 text-[11px] font-semibold text-accent-300">
              <i className="ri-lock-line"></i> 匿名可选
            </span>
          </div>
          <p className="mt-2 text-xs text-primary-300">演示站点：填写后不会真实提交，正式接入后开放。</p>
          <div className="mt-5 flex flex-col gap-3">
            <div>
              <label className="mb-1.5 block text-xs font-semibold text-primary-200">涉及对象 / 事件</label>
              <input
                type="text"
                placeholder="例如：XX 社团换届名单争议"
                className="w-full rounded-md border border-primary-700 bg-primary-900/60 px-3.5 py-2.5 text-sm text-background-50 placeholder:text-primary-400 focus:border-accent-400 focus:outline-none"
              />
            </div>
            <div>
              <label className="mb-1.5 block text-xs font-semibold text-primary-200">事件描述（限 500 字）</label>
              <textarea
                maxLength={500}
                rows={4}
                placeholder="讲清时间、地点、人物与你的依据，证据截图可后续补充…"
                className="w-full resize-none rounded-md border border-primary-700 bg-primary-900/60 px-3.5 py-2.5 text-sm text-background-50 placeholder:text-primary-400 focus:border-accent-400 focus:outline-none"
              ></textarea>
            </div>
            <div className="flex flex-col gap-2 sm:flex-row">
              <button
                type="button"
                className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-bold text-accent-950 hover:bg-accent-400"
              >
                <i className="ri-send-plane-line"></i> 提交线索
              </button>
              <button
                type="button"
                className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-600 px-4 py-2.5 text-sm font-bold text-primary-100 hover:bg-primary-800"
              >
                <i className="ri-question-line"></i> 我是当事人 · 申诉
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}